import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Bell } from "lucide-react";

export default function NotificationBell() {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data.notifications || []);
      setUnread(data.unread || 0);
    } catch {}
  };

  useEffect(() => {
    load();
    const iv = setInterval(load, 15000);
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => { clearInterval(iv); document.removeEventListener("mousedown", handler); };
  }, []);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next && unread > 0) {
      try { await api.post("/notifications/read"); setUnread(0); } catch {}
    }
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={toggle} className="relative p-2 rounded-lg hover:bg-zinc-800/60" data-testid="btn-notif-bell">
        <Bell className="w-5 h-5 text-zinc-300" />
        {unread > 0 && (
          <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-[10px] font-bold flex items-center justify-center" data-testid="notif-badge">
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto cw-glass rounded-xl border border-zinc-800 shadow-2xl z-50">
          <div className="p-3 border-b border-zinc-800 font-semibold text-sm">Notificações</div>
          {items.length === 0 ? (
            <div className="p-6 text-center text-xs text-zinc-500">Sem notificações ainda.</div>
          ) : items.map(n => (
            <Link key={n.notification_id} to={n.shift_id ? `/shifts/${n.shift_id}` : "#"} onClick={() => setOpen(false)}
                  className="block p-3 border-b border-zinc-800/60 hover:bg-zinc-800/50">
              <div className="text-sm font-semibold text-white">{n.title}</div>
              <div className="text-xs text-zinc-400 mt-0.5">{n.body}</div>
              <div className="text-[10px] text-zinc-600 mt-1 font-mono">{n.created_at?.slice(0, 16).replace("T", " ")}</div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
